// components/Footer.tsx
import React from "react";

const Footer = () => (
  <footer className="container-footer d-flex align-items-center text-white">
    <span>Content Owned by Telangana Medical Council</span>
    <span className="dot-separator" aria-hidden="true">
      •
    </span>
    <span>Copy Rights - Designed & Developed by Pinank Solutions</span>
  </footer>
);

export default Footer;
